import userService from '@/services/user'
import { checkApiSuccess } from '../../utils'
import router from '../../router'
import axios from 'axios'
import moment from 'moment'
import {
  SET_DATE_TIME_FORMAT,
  SET_USER_RIGHTS,
  SET_DATE_TIME_FORMATS,
  SET_DATE_TIME_FORMAT_ID,
  SET_USER_PLAN,
  SET_USED_WAREHOUSES,
  SET_USED_ITEMS,
  SET_USED_CUSTOM_FIELDS,
  SET_USED_USERS
} from '../constant/mutation-types'

const falseRights = {
  warehouseView: false,
  warehouseCreate: false,
  warehouseEdit: false,
  warehouseDelete: false,
  itemView: false,
  itemCreate: false,
  itemEdit: false,
  itemDelete: false,
  categoryView: false,
  categoryCreate: false,
  categoryEdit: false,
  categoryDelete: false,
  customFieldView: false,
  customFieldCreate: false,
  customFieldEdit: false,
  customFieldDelete: false,
  integrationManagement: false,
  inventoryImport: false,
  inventoryExport: false,
  reports: false,
  activityHistory: false,
  alertManagement: false,
  roleManagement: false,
  userManagement: false,
  locationView: false,
  locationCreate: false
}

const namespaced = true

const state = {
  user: {},
  status: '',
  error: '',
  invitedUsers: [],
  curUserData: null,
  dateTimeFormat: '',
  rights: {
    loaded: false,
    warehouseView: true,
    warehouseCreate: true,
    warehouseEdit: true,
    warehouseDelete: true,
    itemView: true,
    itemCreate: true,
    itemEdit: true,
    itemDelete: true,
    categoryView: true,
    categoryCreate: true,
    categoryEdit: true,
    categoryDelete: true,
    customFieldView: true,
    customFieldCreate: true,
    customFieldEdit: true,
    customFieldDelete: true,
    integrationManagement: true,
    inventoryImport: true,
    inventoryExport: true,
    reports: true,
    activityHistory: true,
    alertManagement: true,
    roleManagement: true,
    userManagement: true,
    locationView: true,
    locationCreate: true
  },
  dateTimeFormatId: 0,
  dateTimeFormats: [],
  userPlan: {
    customFields: {
      limit: 0,
      used: 0
    },
    items: {
      limit: 0,
      used: 0
    },
    name: 'Free',
    status: 'active',
    users: {
      limit: 0,
      used: 0
    },
    warehouses: {
      limit: 0,
      used: 0
    }
  },
  redirect: '',
  isLoaded: false,
  unpaidError: false
}

const mutations = {
  set(state, { type, val }) {
    state[type] = val
  },
  inviteUser(state, payload) {
    var temp = {
      name: `${payload.firstName} ${payload.lastName}`,
      email: payload.email,
      role: payload.role
    }
    state.invitedUsers.push(temp)
  },
  [SET_DATE_TIME_FORMAT](state, payload) {
    state.dateTimeFormat = payload
  },
  [SET_USER_RIGHTS](state, payload) {
    state.rights = payload
    state.rights.loaded = true
  },
  [SET_DATE_TIME_FORMATS](state, payload) {
    state.dateTimeFormats = payload
  },
  [SET_DATE_TIME_FORMAT_ID](state, payload) {
    state.dateTimeFormatId = payload
  },
  [SET_USER_PLAN](state, payload) {
    if (payload) {
      state.userPlan = payload
    }
    if (!state.isLoaded) state.isLoaded = true
  },
  [SET_USED_WAREHOUSES](state, payload) {
    state.userPlan.warehouses.used = payload
  },
  [SET_USED_ITEMS](state, payload) {
    state.userPlan.items.used = payload
  },
  [SET_USED_CUSTOM_FIELDS](state, payload) {
    state.userPlan.customFields.used = payload
  },
  [SET_USED_USERS](state, payload) {
    state.userPlan.users.used = payload
  }
}

const actions = {

  async login({ dispatch, commit, getters, rootGetters }, payload) {
    dispatch('startFormSubmit', null, { root: true })
    return await userService
      .login(payload)
      .then((response) => {
        if (checkApiSuccess(response)) {
          const token = response.data.data.token

          localStorage.setItem('token', token)
          localStorage.setItem('curUserData', JSON.stringify(response.data.data))
          commit('set', { type: 'curUserData', val: response.data.data })

          axios.defaults.headers.common.Authorization = `Bearer ${token}`

          const redirectAfterAuthorization = (localStorage.getItem('redirectAfterAuthorization'))
          if (redirectAfterAuthorization) {
            localStorage.removeItem('redirectAfterAuthorization')
            window.location = redirectAfterAuthorization
          } else {
            router.push({ name: rootGetters.getRouteAfterLogin || 'Dashboard' }).then(() => {})
          }
        } else {
          if (response.data.error.type !== 200) {
            commit('set', { type: 'error', val: response.data.error.message })
          }
        }
        return response
      })
      .catch(() => {
        localStorage.removeItem('token')
      })
  },

  async register({ dispatch, commit, getters, rootGetters }, payload) {
    dispatch('startFormSubmit', null, { root: true })
    return await userService
      .register(payload)
      .then((response) => {
        if (checkApiSuccess(response)) {
          var token = response.data.data.token
          localStorage.setItem('token', token)
          localStorage.setItem('curUserData', JSON.stringify(response.data.data))
          commit('set', { type: 'curUserData', val: response.data.data })
          axios.defaults.headers.common.Authorization = `Bearer ${token}`

          const redirectAfterAuthorization = (localStorage.getItem('redirectAfterAuthorization'))
          if (redirectAfterAuthorization) {
            localStorage.removeItem('redirectAfterAuthorization')
            window.location = redirectAfterAuthorization
          } else {
            router.push({ name: rootGetters.getRouteAfterLogin || 'Dashboard' }).then(() => {})
          }
        }
        return response
      })
      .catch(() => {
        localStorage.removeItem('token')
      })
  },
  getInvitedUsers({ dispatch, commit }) {
    dispatch('startFormSubmit', null, { root: true })
    userService
      .getInvitedUsers()
      .then((response) => {
        if (checkApiSuccess(response, 'Get Invite users', dispatch)) {
          dispatch('resToPayload', response)
        }
      })
      .catch(() => {})
  },
  update({ dispatch, commit }, payload) {
    dispatch('startFormSubmit', null, { root: true })
    userService
      .update(payload)
      .then((response) => {
        if (checkApiSuccess(response, 'Edit User', dispatch)) {
          localStorage.setItem('curUserData', JSON.stringify(response.data.data))
          commit('set', { type: 'curUserData', val: response.data.data })
          router.push({ name: 'Inventory' }).then(() => { })
        }
      })
      .catch((err) => {
        console.log(err)
      })
  },
  async resToPayload({ state, dispatch, commit }, response) {
    dispatch('startFormSubmit', null, { root: true })
    const payload = []
    if (Array.isArray(response.data.data)) {
      response.data.data.forEach(doc => {
        const tmp = {
          id: doc.id,
          firstName: doc.firstName,
          lastName: doc.lastName,
          email: doc.email,
          role: doc.role,
          phone: doc.phone,
          dateAdded: doc.created == null ? '-' : moment(doc.created).format(state.dateTimeFormat),
          lastActive: doc.lastVisit == null ? '-' : moment(doc.lastvisit).format(state.dateTimeFormat),
          inviteStatus: doc.inviteStatus
        }
        payload.push(tmp)
      })
      if (state.isLoaded) {
        commit(SET_USED_USERS, payload.length)
      }
      commit('set', { type: 'invitedUsers', val: payload })
    }
  },
  async inviteUser({ dispatch, commit }, payload) {
    dispatch('startFormSubmit', null, { root: true })
    return await userService.inviteUser(payload).then((response) => {
      if (checkApiSuccess(response, 'Invite User', dispatch)) {
        dispatch('resToPayload', response)
        router.push({ name: 'Users' })
      }
      return response
    })
  },
  async updateUser({ dispatch, commit }, payload) {
    dispatch('startFormSubmit', null, { root: true })
    return await userService.editInvitedUser(payload).then((response) => {
      if (checkApiSuccess(response, 'Edit User', dispatch)) {
        dispatch('resToPayload', response)
        router.push({ name: 'Users' }).then(() => {})
      }
      return response
    })
  },
  async delInvitedUser({ dispatch, commit }, id) {
    dispatch('startFormSubmit', null, { root: true })
    return await userService.delInvitedUser(id).then((response) => {
      if (checkApiSuccess(response, 'Delete User', dispatch)) {
        dispatch('resToPayload', response)
        return response
      }
    })
  },
  async logout({ dispatch, commit }) {
    dispatch('startFormSubmit', null, { root: true })
    return new Promise((resolve, reject) => {
      localStorage.removeItem('token')
      localStorage.removeItem('curUserData')
      commit('set', { type: 'curUserData', val: null })
      delete axios.defaults.headers.common.Authorization
      resolve()
    })
  },
  async resetPwdReq({ dispatch, commit }, payload) {
    dispatch('startFormSubmit', null, { root: true })
    return await userService.resetPwdReq(payload.email).then((response) => {
      if (checkApiSuccess(response, 'Reset Password', dispatch)) {
        return response
      }
    })
  },
  async tokenConfirm({ dispatch, commit }, payload) {
    dispatch('startFormSubmit', null, { root: true })
    return await userService.tokenConfirm(payload).then((response) => {
      if (checkApiSuccess(response)) {
        return response
      }
    })
  },
  async resetPassword({ dispatch, commit }, payload) {
    dispatch('startFormSubmit', null, { root: true })
    return await userService.resetPassword(payload).then((response) => {
      if (checkApiSuccess(response, 'Reset Password', dispatch)) {
        return response
      }
    })
  },
  async changePassword({ dispatch, commit }, payload) {
    return await userService.changePassword(payload).then((response) => {
      return response
    })
  },
  async profileSettings({ commit }) {
    const resp = await userService.profileSettings()
    const respDateSettings = resp.data.data.settings.dateTimeFormat.value
    const respDateTimeFormats = resp.data.data.references.dateTimeFormat.availableValues
    const respDateTimeFormatId = resp.data.data.settings.dateTimeFormat.id
    commit(SET_DATE_TIME_FORMATS, respDateTimeFormats)
    commit(SET_DATE_TIME_FORMAT, respDateSettings)
    commit(SET_DATE_TIME_FORMAT_ID, respDateTimeFormatId)
    return resp
  },
  async curUserProfile({ commit }) {
    const response = await userService.curUserProfile()
    if (response?.data?.error?.type === 200) {
      localStorage.setItem('curUserData', JSON.stringify(response.data.data))
      commit('set', { type: 'curUserData', val: response.data.data })
      commit(SET_USER_PLAN, response.data.data.plan)
      return response
    }
  },
  async getCurUserRights({ commit }) {
    const response = await userService.curUserProfile()
    if (response?.data?.error?.type === 200) {
      commit(SET_USER_RIGHTS, response.data.data.role.rights)
    } else {
      commit(SET_USER_RIGHTS, falseRights)
    }
  },
  async getUserByToken({ dispatch, commit }, token) {
    return await userService
      .curUserProfile(token)
      .then((response) => {
        if (checkApiSuccess(response)) {
          const token = response.data.data.token
          localStorage.setItem('token', token)
          localStorage.setItem('curUserData', JSON.stringify(response.data.data))
          commit('set', { type: 'user', val: response.data.data })
          axios.defaults.headers.common.Authorization = token
        } else {
          if (response.data.error.type !== 200) {
            commit('set', { type: 'error', val: response.data.error.message })
          }
        }
        return response
      })
      .catch((err) => {
        console.log(err)
      })
  },
  async dateTimeFormatUpdate({ state, dispatch, commit }, payload) {
    return await userService.dateTimeFormatUpdate({ dateTimeFormat: payload.dateTimeFormat }).then((response) => {
      if (response?.data?.error?.type === 200) {
        commit(SET_DATE_TIME_FORMAT, payload.value)
        commit(SET_DATE_TIME_FORMAT_ID, payload.dateTimeFormat)
      }
      return response
    })
  },
  async getAllPlans({ dispatch, commit }) {
    dispatch('startFormSubmit', null, { root: true })
    return await userService.getAllPlans().then((response) => {
      if (checkApiSuccess(response, 'Get Subscription Plans', dispatch)) {
        return response
      }
    })
  },
  async checkoutsession({ dispatch, commit }, payload) {
    dispatch('startFormSubmit', null, { root: true })

    return await userService.checkoutsession(payload).then((response) => {
      if (checkApiSuccess(response, 'Create Subscription', dispatch)) {
        return response.data.data
      }
    })
  },
  async saveSubscription({ dispatch, commit }, payload) {
    dispatch('startFormSubmit', null, { root: true })
    return await userService.saveSubscription(payload).then((response) => {
      if (checkApiSuccess(response, 'Create Subscription', dispatch)) {
        return response.data.data
      }
    })
  },
  removeErrors({ dispatch, commit }) {
    commit('set', { type: 'error', val: '' })
  }
}

const getters = {
  getUserRight: state => right => state.rights[right],
  user(state) {
    return state.curUserData
  },
  selectedInvitedUser() {
    return state.curUserData
  },
  selectedInviteUser(state) {
    return state.user
  },
  getIsOwner: state => state.curUserData?.isOwner,
  invitedUsers: state => state.invitedUsers,
  usersInventories: state => state.curUserData.inventories,
  error(state) {
    return state.error
  },
  getDateTimeFormat: state => state.dateTimeFormat,
  getDateTimeFormats: state => state.dateTimeFormats,
  getDateTimeFormatId: state => state.dateTimeFormatId,
  getUserPlan: state => state.userPlan,
  getUnpaidError: state => state.unpaidError,
  getUserRedirect: state => state.redirect
}

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
